"use client";

import { useMemo } from "react";
import { Loader2 } from "lucide-react";
import { usePathname } from "next/navigation";

type GoogleOAuthButtonProps = {
  intent: "login" | "register";
};

function GoogleIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5">
      <path
        fill="#4285F4"
        d="M22.6 12.2c0-.8-.1-1.5-.2-2.2H12v4.2h5.9c-.3 1.3-1 2.4-2.1 3.1v2.6h3.4c2-1.8 3.4-4.5 3.4-7.7Z"
      />
      <path
        fill="#34A853"
        d="M12 23c3 0 5.5-1 7.3-3.1l-3.4-2.6c-.9.6-2.1 1-3.9 1-3 0-5.5-2-6.4-4.7H2.1v2.7C3.9 20.3 7.7 23 12 23Z"
      />
      <path
        fill="#FBBC05"
        d="M5.6 13.6a6.6 6.6 0 0 1 0-4.2V6.7H2.1a11 11 0 0 0 0 9.8l3.5-2.9Z"
      />
      <path
        fill="#EA4335"
        d="M12 4.7c1.6 0 3.1.6 4.2 1.7l3.1-3.1A10.6 10.6 0 0 0 12 1 11 11 0 0 0 2.1 6.7l3.5 2.7C6.5 6.7 9 4.7 12 4.7Z"
      />
    </svg>
  );
}

export function GoogleOAuthButton({ intent }: GoogleOAuthButtonProps) {
  const pathname = usePathname();

  const href = useMemo(() => {
    const params = new URLSearchParams({ intent });
    if (pathname && pathname !== "/login" && pathname !== "/register") params.set("next", pathname);
    return `/api/auth/google/start?${params.toString()}`;
  }, [intent, pathname]);

  return (
    <a
      href={href}
      className="flex h-14 w-full items-center justify-center gap-3 rounded-xl border border-black/10 bg-white px-4 text-sm font-black text-[#111] shadow-sm transition hover:border-[#A4243B]/30 hover:bg-[#F6F1E3]"
    >
      <GoogleIcon />
      <span>Folytatás Google fiókkal</span>
      <Loader2 className="hidden h-5 w-5 animate-spin text-[#A4243B]" />
    </a>
  );
}
